<!-- Sidebar fija -->
<app-sidebar></app-sidebar>

<!-- Contenido principal -->
<div class="main-content">
  <router-outlet></router-outlet>
</div>